"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const valueFor = (value, type, key) => {
    switch (type) {
        case "json":
            try {
                return JSON.parse(value[type].json);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(`Error parsing JSON from Prefab config ${key}`, e, value[type].json);
                return value[type].json;
            }
        case "duration":
            return {
                seconds: Number(value[type].seconds),
                ms: Number(value[type].seconds) * 1000,
            };
        default:
            return value[type];
    }
};
class Config {
    constructor(key, value, type, metadata) {
        this.key = key;
        this.value = value;
        this.type = type;
        this.configEvaluationMetadata = metadata;
    }
    static digest(rawValues) {
        const configs = {};
        Object.keys(rawValues || {}).forEach((key) => {
            const value = rawValues[key];
            if (typeof value === "object") {
                const type = Object.keys(value)[0];
                configs[key] = new Config(key, valueFor(value, type, key), type, value.configEvaluationMetadata
                    ? this.parseRawMetadata(value.configEvaluationMetadata)
                    : undefined);
            }
            else {
                configs[key] = new Config(key, value, "unknown");
            }
        });
        return configs;
    }
    static parseRawMetadata(metadata) {
        return {
            configRowIndex: parseInt(metadata.configRowIndex, 10),
            conditionalValueIndex: parseInt(metadata.conditionalValueIndex, 10),
            type: metadata.type,
            configId: metadata.id,
        };
    }
}
exports.Config = Config;
